import React from 'react';

interface ExpertiseCardProps {
  title: string;
  description: string;
  noBorder?: boolean;
}

const ExpertiseCard: React.FC<ExpertiseCardProps> = ({ title, description, noBorder }) => {
  return (
    <div className={`expertise-card ${noBorder ? 'no-border' : ''}`}>
      <div className="expertise-card-header">
        <h3 className="expertise-card-title">{title}</h3>
      </div>
      <p className="expertise-card-description">{description}</p>
    </div>
  );
};

export default ExpertiseCard;
